module.exports = __webpack_public_path__ + "static/media/no-image-placeholder@2x.ae8eb89c.svg";